// src/pages/ProductsAccessoriesPage.jsx
import React from "react";
import ProductCard from "../components/ProductCard";
//import allProducts from "../assets/data/products.json";
import allProducts from "../assets/data/processedProducts";
import imageMap from "../assets/data/imageMap";

const ProductsAccessoriesPage = () => {
  const accessories = Object.values(
  allProducts
    .filter((item) => item.Category === "Accessories")
    .reduce((acc, item) => {
      if (!acc[item.Series]) {
        acc[item.Series] = item;
      }
      return acc;
    }, {})
);

  return (
    <div className="container mx-auto p-4 pt-20">
      <h1 className="text-2xl font-bold mb-6">Accessories</h1>

      {accessories.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {accessories.map((product) => (
  <ProductCard
    key={product.ID}
    product={{
      ...product,

      // Display Series instead of Item
      DisplayName: product.Series,

      imageSrc: imageMap[product.Image],
    }}
  />
))}
        </div>
      ) : (
        <div className="text-center text-gray-600 mt-10">
          No accessories found.
        </div>
      )}
    </div>
  );
};

export default ProductsAccessoriesPage;
